import React from "react";

const HisCheckCircle2 = ({ color, sx }) => {
  const strokeColor = color ?? "#4C2AC6";
  const _sx = sx ?? {};

  return (
    <svg style={_sx} viewBox="0 0 117 116" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M58.9757 106.333C85.6702 106.333 107.309 84.6943 107.309 57.9998C107.309 31.3053 85.6702 9.6665 58.9757 9.6665C32.2812 9.6665 10.6423 31.3053 10.6423 57.9998C10.6423 84.6943 32.2812 106.333 58.9757 106.333Z"
        stroke={strokeColor}
        strokeWidth="9.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M44.4756 58.0002L54.1423 67.6668L73.4756 48.3335"
        stroke={strokeColor}
        strokeWidth="9.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default HisCheckCircle2;
